import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/CompanyUsers.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/users'

const RouteCompanyUsers = ({ company, history, ...props }) => (
  <Fragment>
    <PaginatedConnectionTable
      {...props}
      history={history}
      fields={fields}
      onRowClick={(e, row) => history.push(`/admin/users/${row.id}`)}
      showNew
      showManage
    />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'company.users'
})(RouteCompanyUsers)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/users/index.js